import { StreamListFilterParams } from '@anm/api/modules/stream';
import getIsPastStream from '@anm/helpers/stream/getIsPastStream';
import { LiveStream, LiveStreamKind, LiveStreamStatus } from 'types/stream';

import configs from '../../../config';

import { LiveTab } from '.';

type GetRoomUrlProps = {
  id: string;
  kind: LiveStreamKind;
  state: LiveStreamStatus;
};

const { urls } = configs();

export const getStreamStatus = (state: LiveStreamStatus, kind: LiveStreamKind, _schedule: string | null) => {
  switch (true) {
    case kind === 'LIVE':
      return 'live';
    case kind === 'RECORD':
      return 'recording';
    case kind === 'HOSTED':
      return 'hosted';

    case state === 'FAILED':
      return 'failed';
    case state === 'CANCELED':
      return 'canceled';
    case state === 'PAUSED':
      return 'paused';

    default:
      return 'default';
  }
};

export const getRoomUrl = ({ id, kind, state }: GetRoomUrlProps) => {
  const isHosted = kind === 'HOSTED';
  const isRecording = kind === 'RECORD';
  const isPastStream = getIsPastStream(state);
  const skipSetup = isRecording || isPastStream;

  const query = isHosted ? '?hosted' : skipSetup ? `?skipSetup=yes` : '';

  return `${urls.streamingStudio}${id}${query}`;
};

type EmptyListProps = {
  isError?: boolean;
  iconSrc?: string;
  description?: string;
};

export const getEmptyListProps = ({
  isError,
  iconSrc = 'images/icons/lps/eyes_emoji.png',
  description = 'No streams here yet'
}: EmptyListProps) => {
  const icon = isError ? 'images/icons/refresh.png' : iconSrc;
  const title = isError ? 'Something went wrong.<br> Try to refresh' : description;

  return { icon, title };
};

const paramsMap: Record<LiveTab, StreamListFilterParams | null> = {
  past: { state: 'Finished,Canceled,Failed', sort: 'endedAt', offset: 0 },
  upcoming: { state: 'Scheduled', sort: 'updated', offset: 0 },
  'in-progress': { state: 'Inprogress,Paused', sort: 'startedAt', offset: 0 },
  destinations: null
};

export const getStreamParams = (tab = 'upcoming' as LiveTab) => paramsMap[tab];

export const getStreamKey = (stream: LiveStream) => stream.streamId + stream.updated?.split('.')[0];
